import React, { useState } from 'react';
import { COMPRESSED_STOCK_IMAGE_URL, SkeletonTable, Link, useNavigate } from '../Data/Imports';
import ImageViewModal from './Modals/ImageViewModal';
import { MdEditSquare } from '../Data/Icons';

const Tables = ({ headings, data, toggleIsDisplayPortal, loading, fetchProducts }) => {
	const [viewImage, setViewImage] = useState(false);
	const navigate = useNavigate();
	const [updateImageData, setUpdateImageData] = useState({
		ProductId: null,
		currentImagePath: '',
		ImagePreview: '',
		ImageFile: '',
	});

	const handleReset = () => {
		setUpdateImageData({
			ProductId: null,
			currentImagePath: '',
			ImageFile: '',
		});
		setViewImage(false);
	};

	const handleToggle = async (Id, currentValue) => {
		const data = {
			ProductId: Id,
			IsDisplayPortalOn: !currentValue,
		};
		await toggleIsDisplayPortal(data);
	};

	return (
		<div className='overflow-x-auto'>
			{data?.length === 0 ? (
				<p className=' text-center text-gray-600'>
					No products found yet. Let&apos;s get started by adding your first one!{' '}
					<Link to='/add-product' className='text-blue-600 underline hover:text-blue-800'>
						Add Product
					</Link>
				</p>
			) : (
				<table className='w-full border-collapse border border-gray-300 whitespace-nowrap	 '>
					<thead>
						<tr className='bg-gray-200 text-gray-700'>
							<th className='border border-gray-300 px-4 py-2 text-center  '>Action</th>
							{headings?.map((label) => (
								<th key={label.Id} className='border border-gray-300 px-4 py-2 text-center  '>
									{label.LabelHeading}
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{loading ? (
							// Skeleton while the data loads
							<SkeletonTable rows={6} cols={headings?.length} />
						) : (
							data?.map((row, index) => (
								<tr key={index} className='text-gray-600'>
									<td className='text-center'>
										<button
											onClick={() => {
												navigate('/add-product', {
													state: { mode: 'edit', productData: row },
												});
											}}
											className=''>
											<MdEditSquare className='globalButton' />
										</button>
									</td>
									{headings?.map((header, i) => {
										if (header.LabelName === 'IsDisplayPortalOn') {
											return (
												<td key={i} className='border p-3 text-center'>
													<button onClick={() => handleToggle(row.Id, row[header.LabelName])}>
														<label className='relative inline-flex items-center cursor-pointer'>
															<input
																type='checkbox'
																value=''
																className='sr-only peer'
																checked={!!row[header.LabelName]}
																onClick={(e) => e.stopPropagation()}
																readOnly
															/>
															<div
																className={`peer ring-0 bg-[#213555] rounded-full outline-none duration-300 after:duration-500 w-8 h-8 shadow-md peer-checked:bg-[#a9c46c] peer-focus:outline-none 
      after:rounded-full after:absolute after:outline-none after:h-6 after:w-6 after:bg-gray-50 
      after:top-1 after:left-1 after:flex after:justify-center after:items-center peer-hover:after:scale-75 
      ${row[header.LabelName] ? 'after:content-["✔️"] after:rotate-0' : 'after:content-["✖️"] after:-rotate-180'}`}></div>
														</label>
													</button>
												</td>
											);
										}

										if (header.LabelName === 'ParentImagePath') {
											return (
												<td key={i} className='border p-3 text-center'>
													{row[header.LabelName] ? (
														<img
															src={`${COMPRESSED_STOCK_IMAGE_URL}/${row[header.LabelName]}`}
															alt='ParentImage'
															className='w-16 h-16 object-cover rounded cursor-pointer'
															onClick={() => {
																setViewImage(true);
																setUpdateImageData({
																	ProductId: row?.Id,
																	currentImagePath: row[header?.LabelName],
																	ImageFile: '',
																});
															}}
														/>
													) : (
														<span className='text-gray-400'>No Image</span>
													)}
												</td>
											);
										}

										return (
											<td key={i} className='border px-4 py-2 text-center'>
												{row[header.LabelName] ?? '-'}
											</td>
										);
									})}
								</tr>
							))
						)}
					</tbody>
				</table>
			)}

			{viewImage && (
				<ImageViewModal
					setViewImage={setViewImage}
					updateImageData={updateImageData}
					setUpdateImageData={setUpdateImageData}
					handleReset={handleReset}
					fetchProducts={fetchProducts}
				/>
			)}
		</div>
	);
};

export default Tables;
